module.exports = __webpack_public_path__ + "img/21_21.12f6383f.png";